

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {IPromotion} from "@/model/Promotions/IPromotion";
  import {Prop} from "vue-property-decorator";

  @Component({
    name: 'PromotionOriginIcon',
    components: {}
  })
  export default class PromotionOriginIcon extends Vue {

    @Prop()
    protected promotion!: IPromotion;

    protected get isOriginMgm() {
      const promotion = this.promotion;
      return promotion.visibility.match(/^[0-9]+$/) &&
          promotion.notes.match(/^Created for MGM/);
    }
    protected get isOriginPersonal() {
      const promotion = this.promotion;
      return promotion.visibility.match(/^[0-9]+$/);
    }

  }

